<style lang='less' scoped>
@import '../base.less';
</style>
<template>
  <div>
    <!-- SEARCH -->
    <Row>
      <Col span="24">
        <Card class="margin-bottom-10">
          <Form inline>
            <FormItem class='margin-bottom-0'>
              <Input clearable v-model='searchConf.username' :placeholder="$t('请输入会员帐号') "></Input>
            </FormItem>
            <FormItem style="margin-bottom: 0">
              <DatePicker type="datetimerange" :options="timeOptions" :value='searchConf.searchTime'
                          @on-change='timeChange' format="yyyy-MM-dd HH:mm:ss"
                          :placeholder="$t('选择时间')" style="width: 300px">
              </DatePicker>
            </FormItem>
            <FormItem class="margin-bottom-0">
              <Button type="primary" @click="search">{{ $t('find_button') }}</Button>
            </FormItem>
          </Form>
        </Card>
      </Col>
    </Row>        <!--    -->
    <Row>
      <Col span='24'>
        <Card>
          <!-- ADDBUTTON -->
          <div class='margin-bottom-15'>
            <Button type='primary' v-has="'userManage/userRechargeBlack/add'" @click='preAdd' icon='md-add'>
              {{ $t('add_button') }}
            </Button>
          </div>
          <!-- DATA -->
          <div>
            <Table :loading='listLoading' :columns='columnsList' :data='tableData' border></Table>
          </div>
          <!-- PAGE -->
          <div class='margin-top-15' style='text-align: center'>
            <Page :total='tableShow.listCount' :current='tableShow.currentPage' :page-size='tableShow.pageSize'
                  @on-change='changePage' @on-page-size-change='changeSize'
                  :page-size-opts='[10,20,30,40,50,100,200,300]' show-elevator show-sizer show-total></Page>
          </div>
        </Card>
      </Col>
    </Row>
    <!-- windowAddEdit -->
    <Modal v-model="windowAdd.show" width="668" :styles="{top: '30px'}" @on-visible-change="windowAddCancel">
      <p slot="header" style="color:#2d8cf0">
        <Icon type="md-alert"></Icon>
        <span>{{ windowAddItem.id ? $t('编辑') : $t('新增') }}</span>
      </p>
      <Form ref="windowAddForm" :rules="windowAddValidate" :model="windowAddItem" :label-width="80">
        <FormItem label='会员帐号' prop='username'>
          <Input v-model='windowAddItem.username' :placeholder="$t('请输入会员帐号,多个以逗号隔开')" :disabled="windowAddItem.id"></Input>
        </FormItem>
        <FormItem label='备注信息' prop='remark'>
          <Input v-model='windowAddItem.remark' :placeholder="$t('请输入备注信息')"></Input>
        </FormItem>
        <FormItem label="限制类型" prop="app_api">
          <div class="api-box">
            <div class="api-group">
              <div style="border-bottom: 1px solid #e9e9e9;padding-bottom:6px;margin-bottom:6px">
                <Checkbox v-model="windowAddItem.checkAll" @on-change='checkBoxAll' style="display: inline-block;">
                  {{ $t('全选') }}
                </Checkbox>
              </div>
              <CheckboxGroup style="display: inline-block;" @on-change='checkboxGroupChange'
                             v-model="windowAddItem.banTypes">
                <Checkbox  :key="key" :label="value.id"
                          v-for="(value, key) in windowAdd.banList"> {{ value.type_name }}
                </Checkbox>
              </CheckboxGroup>
            </div>
          </div>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" @click="windowAddCancel()" class="margin-right-10">{{ $t('取消') }}</Button>
        <Button type="primary" @click="windowAddSubmit" :loading="windowAdd.loading">{{ $t('确定') }}</Button>
      </div>
    </Modal>
    <!--    -->
  </div>
</template>
<script>
import {
  getList,
  add,
  del,
  getRechargeBillTypes,
} from '@/api/userManage/userRechargeBlack'
import {
  formattingMonth,
  lastMonthDate
} from '@/libs/time'

export default {
  name: 'interface_list',
  data () {
    return {
      timeOptions: {
        shortcuts: [{
          text: '今天',
          value () {
            let a = new Date(new Date(new Date().toLocaleDateString()).getTime())
            let b = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)
            return [a, b]
          }
        },
          {
            text: '昨天',
            value () {
              let a = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000)
              let b = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000 + 24 * 60 *
                60 * 1000 - 1)
              return [a, b]
            }
          },
          {
            text: '一周',
            value () {
              let a = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000 * 7)
              let b = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)
              return [a, b]
            }
          },
          {
            text: '本月',
            value () {
              return formattingMonth()
            }
          },
          {
            text: '上月',
            value () {
              return lastMonthDate()
            }
          },
        ]
      },
      columnsList: [{
        title: this.$t('会员帐号'),
        key: 'username',

        minWidth: 120,
        align: 'center'
      }, {
        title: this.$t('限制类型'),
        key: 'banStr',

        minWidth: 250,
        align: 'center'
      }, {
        title: this.$t('修改人'),
        key: 'admin_name',

        minWidth: 120,
        align: 'center'
      }, {
        title: this.$t('修改时间'),
        key: 'update_time',

        minWidth: 120,
        align: 'center'
      }, {
        title: this.$t('备注'),
        key: 'remark',

        minWidth: 120,
        align: 'center'
      }, {
        title: this.$t('操作'),
        align: 'center',
        minWidth: 120,
        render: (h, params) => {
          let vm = this
          return h('div', [h('Button', {
            props: {
              type: 'primary'
            },
            style: {
              margin: '0 5px'
            },
            on: {
              'click': () => {
                if (vm.windowAdd.banList == null) {
                  getRechargeBillTypes().then(response => {
                    vm.windowAdd.banList = response.data.data
                  })
                }
                vm.windowAddItem.id=params.row.id;
                vm.windowAddItem.username=params.row.username;
                vm.windowAddItem.remark=params.row.remark;
                vm.windowAddItem.banTypes = params.row.ban_bill_ids;
                vm.windowAdd.show = true;
              }
            }
          }, this.$t('编辑')), h('Poptip', {
            props: {
              confirm: true,
              title: this.$t('您确定要删除这条数据吗?'),
              transfer: true
            },
            on: {
              'on-ok': () => {
                del(params.row.id).then(response => {
                  this.tableData.splice(params.index, 1)
                  this.$Message.success(response.data.msg)
                })
                params.loading = false
              }
            }
          }, [
            h('Button', {
              style: {
                margin: '0 5px'
              },
              props: {
                type: this.$t('error'),
                placement: 'top',
                loading: params.isDeleting
              }
            }, this.$t('删除'))
          ])])
        }
      },],
      tableData: [],//用于放LIST数据绑定
      tableShow: { //用于分页
        currentPage: 1,
        pageSize: 10,
        listCount: 0
      },
      searchConf: { searchTime: [], }, // 搜索字段

      buttonShow: { //按钮状态显示
        edit: true,
        del: true,
        changeStatus: true
      },
      listLoading: false, //显示加载中状态
      //弹窗--------------
      windowAdd: { //弹窗
        show: false,
        loading: false,
        index: 0,
        banList: null
      },
      windowAddItem: { //弹窗数据绑定
        id: 0,
        banTypes: []
      },
      windowAddValidate: {//窗口校验规则
      },                            //----------------
    }
  },
  created () {
    let vm = this
    vm.getList()
    vm.hasRule('userManage/userRechargeBlack/edit').then(res => {
      vm.buttonShow.edit = res
    })
    vm.hasRule('userManage/userRechargeBlack/del').then(res => {
      vm.buttonShow.del = res
    })
    vm.hasRule('userManage/userRechargeBlack/changeStatus').then(res => {
      vm.buttonShow.changeStatus = res
    })
  },
  methods: {
    preAdd () {
      let vm = this
      if (vm.windowAdd.banList == null) {
        getRechargeBillTypes().then(response => {
          vm.windowAdd.banList = response.data.data
        })
      }
      vm.windowAddItem.id=0;
      vm.windowAddItem.username="";
      vm.windowAddItem.remark="";
      this.windowAddItem.banTypes = [];
      vm.windowAdd.show = true
    },
    changePage (page) {
      this.tableShow.currentPage = page
      this.getList()
    },
    changeSize (size) {
      this.tableShow.pageSize = size
      this.getList()
    },
    search () {
      this.tableShow.currentPage = 1
      this.getList()
    },
    getList () {
      let vm = this
      vm.listLoading = true
      getList({
        page: vm.tableShow.currentPage,
        size: vm.tableShow.pageSize,
        search: vm.searchConf
      }).then(response => {
        vm.tableData = response.data.data.list
        vm.tableShow.listCount = response.data.data.count
        vm.listLoading = false
      })
    },

    timeChange (datetimerange) { //时间修改，自动计算尾部时间
      if (datetimerange[0] !== '' && datetimerange[1] !== '') {
        let patt = /00:00:00/
        this.searchConf.searchTime = [datetimerange[0], datetimerange[1]]
        if (patt.test(datetimerange[1])) {
          datetimerange[1] = datetimerange[1].replace('00:00:00', '23:59:59')
          this.searchConf.searchTime = [datetimerange[0], datetimerange[1]]
        }
      } else {
        this.searchConf.searchTime = []
      }
    },
    sortChange: function ({ column, key, order }) {
      //order值可能为asc,desc,normal
      this.searchConf.order = [key, order]
      if (order == 'normal') {
        this.searchConf.order = []
      }
      this.getList()
    },
    windowAddCancel (data) {
      if (!data) {
        this.windowAddItem.id = 0
        this.$refs['windowAddForm'].resetFields()
        this.windowAdd.show = false
        this.windowAdd.loading = false
        this.windowAdd.index = 0
      }
    }, windowAddSubmit () {
      let vm = this
      vm.$refs['windowAddForm'].validate((valid) => {
        if (valid) {
          vm.windowAdd.loading = true
          if (vm.windowAddItem.id === 0) {
            add(vm.windowAddItem).then(response => {
              vm.$Message.success(response.data.msg)
              vm.getList()
              vm.windowAddCancel()
            }).catch(() => {
              vm.windowAdd.loading = false
            })
          } else {
            add(vm.windowAddItem).then(response => {
              vm.$Message.success(response.data.msg)
              vm.getList()
              vm.windowAddCancel()
            }).catch(() => {
              vm.windowAdd.loading = false
            })
          }
        }
      })
    },
    checkboxGroupChange (e) {

      if (e.length == this.windowAdd.banList.length) {
        this.windowAddItem.checkAll = true
      } else {
        this.windowAddItem.checkAll = false
      }
    },
    checkBoxAll (val) {
      if (val) {
        for (var i = 0; i < this.windowAdd.banList.length; i++) {
          this.windowAddItem.banTypes.push(this.windowAdd.banList[i]['id'])
        }
        //this.windowAddItem.banTypes = [1,2,3,5,4,18,11,10,6]
      } else {
        this.windowAddItem.banTypes = []
      }
    },
  }
}
</script>
